<template>
    <div>
        <LoadingSpinner v-if="isLoading" message="Loading data..." />
        <div v-else>
      

            <div id="page-wrapper">
        
            
            
                <!-- Header -->
                <section id="header" class="wrapper">  </section>
            
                <div id="main" class="wrapper style2">

                    <div class="container">

                        <div id="content">

                            <article class="box post">

                                <header class="style1">

                                    <h2>{{ $t('customerSurvey') }}</h2>
                                    
                                </header>

                                <form @submit.prevent="submitData" method="POST">

                                    <div class="row gtr-50">
     

                                        <div class="col-12">
                                            <label for="exampleInputEmail1" class="form-label"> {{ $t('merekomendasikanLinc') }} </label>
                                            
                                            <div class="form-check">
                                                <input v-model="forms.merekomendasikan_linc" class="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault1" value="1">
                                                <label class="form-check-label" for="flexRadioDefault1">
                                                    {{ $t('yes') }}
                                                </label>
                                            </div>
                                            <div class="form-check">
                                                <input v-model="forms.merekomendasikan_linc" class="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault1" value="0">
                                                <label class="form-check-label" for="flexRadioDefault1">
                                                    {{ $t('no') }}
                                                </label>
                                            </div>

                                        </div>


                                        <div class="col-6 col-12-small">
                                            <label for="exampleInputEmail1" class="form-label"> {{ $t('kesanLinc') }} <span style="color:red;">*</span></label>
                                            <textarea v-model="forms.kesan_dengan_linc" id="contact-message" placeholder="Message" rows="4" required></textarea>
                                        </div>
                                        
                                        <div class="col-6 col-12-small">
                                            <label for="exampleInputEmail1" class="form-label"> {{ $t('tingkatkanLinc') }} <span style="color:red;">*</span></label>
                                            <textarea v-model="forms.hal_yang_perlu_ditingkatkan" id="contact-message" placeholder="Message" rows="4" required></textarea>
                                        </div>
        

                                        <div class="col-12">
                                            <ul class="actions">
                                                <li><input type="submit" class="style1" :value="$t('submitQuestion')" /></li>
                                            </ul>
                                        </div>

                                    </div>


                                </form>



                            </article>

                        </div>

                    </div>

                </div>


            </div>
            

        </div>
    </div>


</template>


<script>

import LoadingSpinner from './LoadingSpinner.vue';

export default {

    name: "LastPage",
    components: {
        LoadingSpinner,
    },

    props: {

        locales: String,

    },

    data() {
    return {
        isLoading:true,
        errors:[],
        forms: {
            customer_name:"",
            customer_departement:"",
            customer_email:"",
            customer_company:"",
            linc_logistics:0,
            linc_express:0,
            linc_impex:0,
            linc_terminal:0,
            merekomendasikan_linc:1,
            kesan_dengan_linc:"",
            hal_yang_perlu_ditingkatkan:"",
            years:"",
        },
        detailsForm:[],
        details:[],
        langs: [
            {
            name:"Indonesia",
            value:"id"
            },
            {
            name:"English",
            value:"en"
            }
        ],
        selectedLang: "",
        locale: "",
    };
    },

    computed: {
    
    },

    watch: {
        
        locales: {
            handler(newVal) {
                this.selectedLang = newVal;
            },
            immediate: true,
            deep: true,
        },

    },

    methods: {

        langChanged(lang) {
            this.locale       = lang;
            this.$i18n.locale = lang;
            localStorage.Lang = lang;
        },

        submitData(){
            this.errors = [];

            this.$swal({
                title: this.$t("areYouSure"),
                text: '',
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes!",
            }).then((result) => {
                
                if (result.value) {

                    this.isLoading  = true;
  
                    if (this.forms.kesan_dengan_linc === '' || this.forms.kesan_dengan_linc === null || typeof this.forms.kesan_dengan_linc === 'undefined') {

                        this.errors.kesan_dengan_linc = [ this.$t("kesan_dengan_lincWajibIsi") ];
                        
                        this.error( this.$t("kesan_dengan_lincWajibIsi") );
                        
                    }

                    if (this.forms.hal_yang_perlu_ditingkatkan === '' || this.forms.hal_yang_perlu_ditingkatkan === null || typeof this.forms.hal_yang_perlu_ditingkatkan === 'undefined') {

                        this.errors.hal_yang_perlu_ditingkatkan = [ this.$t("hal_yang_perlu_ditingkatkanWajibIsi") ];
                        
                        this.error( this.$t("hal_yang_perlu_ditingkatkanWajibIsi") );
                        
                    }
 
                    const baseURI = this.$settings.endPointCeisa + "v1/survey-2025/submit-data/" + this.$route.params.id;

                    this.forms.details = this.details;

                    return this.$http.post(baseURI, this.forms, { timeout: 100000 }).then((response) => {
                                this.isLoading = false;
                                if (response.status == 200) {
                                    localStorage.removeItem("questionId");
                                    localStorage.removeItem("formDataHeader");
                                    localStorage.removeItem("formDataDetails");
                                    this.$router.push("/done");
                                }
                            }).catch((error) => {
                                this.isLoading = false;
                                if (error.code == "ECONNABORTED") {
                                    this.error(this.$t("check_internet_connection_txt"));
                                } else {
                                    if (error.response) {
                                        if (error.response.status === 422) {
                                            this.errors = error.response.data.errors;
                                            this.resultError(error.response.data.errors);
                                        } else if (error.response.status === 401) {
                                            this.logout();
                                        } else if (error.response.status === 403) {
                                            this.$router.push("/authorized-error");
                                        } else if (error.response.status === 500) {
                                            this.$router.push("/server-error");
                                        } else {
                                            this.$router.push("/page-not-found");
                                        }
                                    }
                                }
                            });



                }

            });

        },

        resultError(data) {
            var count = Object.keys(data).length;
            for (var x = 0; x < count; x++) {
                var nameOb = Object.keys(data)[x];
                var objectData = data[nameOb];
                for (var y = 0; y < objectData.length; y++) {
                this.error(objectData[y]);
                }
            }
        },

        error(kata) {
            const Toast = this.$swal.mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
                didOpen: (toast) => {
                toast.addEventListener("mouseenter", this.$swal.stopTimer);
                toast.addEventListener("mouseleave", this.$swal.resumeTimer);
                },
            });
            Toast.fire({
                icon: "error",
                title: kata,
            });
        },

        loadData() {
            
            if (localStorage.getItem("questionId") !== null) {

                if (localStorage.getItem("questionId") == this.$route.params.id) {

                    if (localStorage.getItem("formDataHeader") !== null) {

                        let dummy = JSON.parse(localStorage.getItem("formDataHeader"));
                        let dummyDetails = JSON.parse(localStorage.getItem("formDataDetails"));
                        this.forms = dummy;
                        this.details = dummyDetails;
                        this.isLoading  = false;

                        // console.log(this.forms)

                        // console.log(this.forms)

                    }else{

                        localStorage.removeItem("questionId");
                        localStorage.removeItem("formData");
                        this.isLoading  = false;
                        window.location.href = '/survey/' + this.$route.params.id;

                    }

                } else {

                    localStorage.removeItem("questionId");
                    localStorage.removeItem("formData");
                    this.isLoading  = false;
                    window.location.href = '/survey/' + this.$route.params.id;

                }

            }else{

                this.isLoading  = false;
                window.location.href = '/survey/' + this.$route.params.id;

            }

        },
    

    },


    events: {

    },

    created: function () {
    
    },

    mounted() {
         
        this.loadData(); 

    },

    updated() {


    },

    onLoad(){


    }


}
</script>

<style scoped>

</style>